module.exports = __webpack_public_path__ + "img/enroulement.06a6135.svg";